import { Box, CardHeader, Typography } from "@mui/material"
import {
	MainDetailsCommonContainer,
	MainDetailsCommonContainerItems,
} from "./MainDetailsCommon"

export default function MainDetailsBody({ title, ItemsWrapper = [], noUsePaper }) {
	return (
		<MainDetailsCard title={title} noUsePaper={noUsePaper}>
			<Box
				display={"flex"}
				gap={1}
				flexWrap="wrap"
				flexDirection={{ xs: "column", sm: "row" }}
				justifyContent="left"
			>
				{ItemsWrapper.map((item) => (
					<MainDetailsBodyItemsWrapper key={item?.id || item.label} {...item} />
				))}
			</Box>
		</MainDetailsCard>
	)
}
export function MainDetailsCard({ title, children, noUsePaper }) {
	return (
		<MainDetailsCommonContainer {...{ noUsePaper }}>
			{title && (
				<CardHeader
					title={
						<Typography
							variant="h6"
							fontWeight="600"
							color="text.primary"
							sx={{ textTransform: "uppercase" }}
						>
							{title}
						</Typography>
					}
				/>
			)}
			{children}
		</MainDetailsCommonContainer>
	)
}

const MainDetailsBodyItemsWrapper = ({
	label,
	value,
	Icon,
	hidden,
	maxWidth = "200px",
	minWidth = "200px",
	button,
}) => {
	if (!value || hidden) return null
	return (
		<Box flex="1 1 auto" minWidth={minWidth} maxWidth={maxWidth}>
			<MainDetailsCommonContainerItems {...{ label, value, Icon, button }} />
		</Box>
	)
}
